import React from 'react';
import styles from './NotFound.module.scss';

import './NotFound.module.scss';
import { commonVaribles } from 'src/constants/constVariables';

export const NotFound = ({ message = commonVaribles.data_not_found }) => {
	return <span className={styles.dataNotfound}>{message}</span>;
};
